import Help from 'components/activity/help/main/container/HelpContainer';
import ZendeskFAQsItem from 'components/activity/help/zendeskFAQsItem/containers/ZendeskFAQsItemContainer';

const helpRoutes = [
    { path: ':id', element: <ZendeskFAQsItem />, pageTitle: 'Help' },
    { path: '', element: <Help />, pageTitle: 'Help' },
];

export default helpRoutes;
